// App.js
import { Suspense, lazy } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./pages/userkezeles/AuthContext";
import { PermissionsProvider } from "./pages/userkezeles/PermissionContext";
import { QueryClient, QueryClientProvider } from "react-query";
import ScrollToTop from "./utils/ScrollTop";

import "bootstrap/dist/css/bootstrap.min.css";
import "./colors.css";
import "./particles.css";

import LazyRoutes from "./LazyRoutes";

const LazyFooter = lazy(() => import("./components/Footer"));
const LazyCookieNotification = lazy(() =>
  import("./components/CookieNotification")
);
const LazyIranyitopult = lazy(() => import("./components/Iranyitopult"));
const LazyParticles = lazy(() => import("./ParticlesWrapper"));

const queryClient = new QueryClient();

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient} contextSharing={true}>
        <Router>
          <ScrollToTop />
          <Suspense fallback={<div style={{ height: "100vh" }} />}>
            <LazyParticles />
          </Suspense>

          <div
            style={{ position: "relative", zIndex: 1 }}
            className="container"
          >
            <AuthProvider>
              <PermissionsProvider>
                <Suspense fallback={<div style={{ height: "100px" }} />}>
                  <LazyIranyitopult />
                </Suspense>
                <LazyRoutes />
              </PermissionsProvider>
            </AuthProvider>

            <Suspense fallback={<div style={{ height: "200px" }} />}>
              <LazyFooter />
              <LazyCookieNotification />
            </Suspense>
          </div>
        </Router>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
